import { render, staticRenderFns } from "./EmployeeAwayApplicationPageTable.vue?vue&type=template&id=79f4d4f9&scoped=true&"
import script from "./EmployeeAwayApplicationPageTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeAwayApplicationPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f4d4f9",
  null
  
)

export default component.exports